export default {"src":"/_next/static/media/cio-review.231845cf.svg","height":44,"width":71,"blurWidth":0,"blurHeight":0};